import React from "react";

const ArrowCircleFullRight = ({ style = {}, onClick }) => (
  <svg
    onClick={onClick}
    style={style}
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6021 31.9195C25.5366 31.9195 31.9688 25.4873 31.9688 17.5528C31.9688 9.61827 25.5366 3.18607 17.6021 3.18607C9.66755 3.18607 3.23535 9.61827 3.23535 17.5528C3.23535 25.4873 9.66755 31.9195 17.6021 31.9195Z"
      fill="#585E66"
    />
    <path
      d="M15.7925 22.6243L20.8496 17.5528L15.7925 12.4814"
      stroke="#EFF1F5"
      strokeWidth="2.25176"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowCircleFullRight;
